document.addEventListener("DOMContentLoaded", function () {
  // Initialisation de la fonction timeline
  function initTimeline() {
    timeline(document.querySelectorAll('.timeline'), {
      mode: 'horizontal',
      visibleItems: window.innerWidth > 1023 ? 4 : window.innerWidth > 767 ? 2 : 1,
      forceVerticalMode: 1,
      moveItems: window.innerWidth > 1023 ? 4 : window.innerWidth > 767 ? 2 : 1,
    });
  }

  // Appel initial
  initTimeline();

  // Débouncer pour la réinitialisation
  let resizeTimeout;
  window.addEventListener('resize', function () {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }
    resizeTimeout = setTimeout(function () {
      // Réinitialisation de la fonction timeline après 500ms
      initTimeline();
    }, 500);
  });


});